export * from '@primeuix/themes/material/overlaybadge';
export { default } from '@primeuix/themes/material/overlaybadge';
